export const SET_ASSETS = 'SET_ASSETS'
export const APPEND_ASSETS = 'APPEND_ASSETS'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_SHOW_MAP = 'SET_SHOW_MAP'

const setAssets = (assets, state) => {
  return { ...state, assets }
}

const appendAssets = (assets, state) => {
  let updatedAssets = [...state.assets]
  updatedAssets = updatedAssets.concat(assets)

  return { ...state, assets: updatedAssets }
}

const setFilters = (filters, state) => {
  return { ...state, filters }
}

const setShowMap = (showMap, state) => {
  return { ...state, showMap }
}

export const directoryReducer = (state, action) => {
  switch (action.type) {
    case SET_ASSETS:
      return setAssets(action.assets, state)
    case APPEND_ASSETS:
      return appendAssets(action.assets, state)
    case SET_FILTERS:
      return setFilters(action.filters, state)
    case SET_SHOW_MAP:
      return setShowMap(action.showMap, state)
    default:
      return state
  }
}
